import styled from "@emotion/styled";
import React from "react";
import { ButtonHTMLAttributes } from "react";
import { SizedImage } from "@/components/SizedImage";
import { linkColor } from "@/theme";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

const StyledButton = styled.button`
  width: 64px;
  height: 64px;
  padding: 0px;
  transition: 0.2s opacity;
  border: 0;
  display: flex;
  background-color: hsl(var(--color-white));
  outline: 1px solid ${linkColor};
  margin: 6px 0px 6px 0px;

  &:focus-visible {
    outline: 2px solid ${linkColor};
  }

  /* Since the focused thumbnail won't show the
     focus-visible style, we add an inset box-shadow */
  &:focus-visible::after {
    box-shadow: 0 0 0 1px hsl(var(--color-gray-900) / 0.15) inset,
      0 0 6px hsl(var(--color-gray-900) / 0.2) inset;
    content: "";
    position: absolute;
    display: block;
    height: 64px;
    width: 64px;
    pointer-events: none;
  }
`;

type ThumbnailButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  selected: boolean;
  alt: string;
  thumbnailSrc: string;
  mediaType: "image" | "video";
};

export const ThumbnailButton = ({
  selected,
  thumbnailSrc,
  alt,
  mediaType,
  ...props
}: ThumbnailButtonProps) => {
  return (
    <StyledButton
      role="radio"
      aria-checked={selected}
      className="group outline-primary aria-checked:outline aria-checked:outline-[3px]"
      {...props}
    >
      {mediaType === "video" && (
        <PlayCircleOutlineIcon className="absolute z-10 block h-16 w-full p-2 text-white transition duration-500 hover:scale-110" />
      )}
      <SizedImage
        className="opacity-70 hover:opacity-100 group-aria-checked:opacity-100"
        data-id="thumbnail-image"
        height={64}
        width={64}
        src={thumbnailSrc}
        alt={alt}
      />
    </StyledButton>
  );
};
